import { z } from "zod"

import { powurOsProposalAdderSchema } from "../models/proposal-adder"

export const postProposalAddersResponseSchema = z.object({
  model: z.object({
    adderRegion: z.string(),
    adders: z.array(powurOsProposalAdderSchema),
    ahj: z.string(),
    utility: z.array(z.string()).optional(),
  }),
})

export type PowurOsPostProposalAdders = z.infer<
  typeof postProposalAddersResponseSchema
>
